export default __webpack_public_path__ + "static/media/logo_fck.0581d237.png";